import { NumericFormat } from "react-number-format";

export default function FormattedNumber({ value, suffix }) {
  return (
    <NumericFormat
      value={+value}
      decimalSeparator=","
      suffix={suffix || " Ft"}
      thousandSeparator="."
      displayType="text"
    />
  );
}
